/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Generate_LinkInputs */

const en_generate_link = /** @type {(inputs: Generate_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Link`)
};

const es_generate_link = /** @type {(inputs: Generate_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar link`)
};

/**
* | output |
* | --- |
* | "Generate Link" |
*
* @param {Generate_LinkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const generate_link = /** @type {((inputs?: Generate_LinkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Generate_LinkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_generate_link(inputs)
	return es_generate_link(inputs)
});